export interface AssessmentUploadSubmission {
	submittedAssessmentId: string;
	submittedAssessmentVersion: number;
	uploads: { id: string; fileName: string }[];
}

export const ASSESSMENT_UPLOAD_VALIDATORS = {
	accept: ".pdf,.docx,.doc",
	maxFileSize: 50 * 1024 * 1024,
} as const;

export const ASSESSMENT_UPLOAD_MAX_FILES = 20;

export interface DeleteAssessmentUpload {
	submittedAssessmentId: string;
	submittedAssessmentVersion: number;
	uploadId: string;
	uploadVersion: number;
}
